var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "infinite", staticClass: "insety-16", attrs: { id: "infinite" } },
    [
      _c("span", { staticClass: "insetx-8" }, [
        _vm._v(_vm._s(_vm.$t("loading_more_results"))),
      ]),
      _c("ib-progress-dots"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }